/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { customProductPipLoaded } from '../../../analytics';
import { FULFILLMENT_TYPES } from '../../../utils/fulfillment-utils';

export default (set, get, productData, thdStore, configurator, autobahnProductInfo) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const productImpressions = [];
  const { options, metadata } = configurator;

  const buildProductInfo = (item, position) => {
    const services = item?.fulfillment?.fulfillmentOptions?.[0].services;
    const bBodfs = services?.find((service) => service.type === FULFILLMENT_TYPES.bodfs);
    const bSth = services?.find((service) => service.type === FULFILLMENT_TYPES.sth);
    const bBopis = services?.find((service) => service.type === FULFILLMENT_TYPES.bopis);
    const bBoss = services?.find((service) => service.type === FULFILLMENT_TYPES.boss);

    const productInfo = {
      sku: item?.itemId,
      customProduct: 'not custom catalog',
      position,
      sponsored: 'false',
      storeType: 'anchor',
      availabilityStatus: {
        shipping: {
          skuStatus: 'n/a',
        },
        store: {
          skuStatus: 'n/a',
        },
        type: 'online'
      }
    };

    if (bBodfs) { productInfo.availabilityStatus.shipping.bodfs = 'available'; }
    if (bSth) { productInfo.availabilityStatus.shipping.sth = 'available'; }
    if (bBopis) { productInfo.availabilityStatus.store.bopis = 'available'; }
    if (bBoss) { productInfo.availabilityStatus.store.boss = 'available'; }

    return (productInfo);
  };

  Object.keys(options).map((option) => {
    let position = 0;
    options?.[option]?.choices.map((choiceId) => {
      position += 1;
      const item = productData?.[metadata?.[choiceId]?.metadata?.Sku];
      if (!item) return;
      const productInfo = buildProductInfo(item, position);
      if (item?.badges?.length > 0) {
        const badge = [];
        item?.badges.map((badgeItem) => badge.push({
          name: badgeItem.name,
          recommendationStrategy: 'n/a',
          recommendationVersion: 'n/a',
          type: 'price',
        }));
        productInfo.badge = badge;
      }
      productImpressions.push({ productInfo });
    });
  });

  if (!draft.digitalData.configuratorPageLoad || !autobahnProductInfo) return;

  const {
    partnerProductId = '325168962',
    productName,
    brand,
    logEventsToConsole,
    omnitureInfo,
    sendPaymentEstimatorImpressionToAnalytics,
    pageType
  } = draft.digitalData.configuratorPageLoad ?? {};

  /* eslint-disable-next-line max-len */
  const name = `${autobahnProductInfo?.brand.toLowerCase()} ${autobahnProductInfo?.displayName.toLowerCase()} configurator`;
  const defaultPageName = 'tools>tool storage>modular tool storage systems>' + name;
  const pageName = omnitureInfo?.subCategory2 || defaultPageName;

  customProductPipLoaded(
    partnerProductId,
    productName,
    brand,
    logEventsToConsole,
    omnitureInfo,
    sendPaymentEstimatorImpressionToAnalytics,
    thdStore,
    productImpressions,
    pageType,
    pageName
  );
}), false, { type: 'TRACK_PAGE_LOAD_WITH_PRODUCT_IMPRESSIONS' });
